import {
  DEAL_SHEET_PROGRAM_TYPE_NAME,
  ACTIVE_STATUS_COMMON_NAME,
} from '@/utils/enum-name';
import { convertToDateSlash, DATE_FORMAT } from '@/utils/date';

export const mapDealSheetListItem = (item, index, page = 1, limit = 10) => {
  const startDate = convertToDateSlash(item.startDate, DATE_FORMAT);
  const endDate = convertToDateSlash(item.endDate, DATE_FORMAT);

  return {
    ...item,
    index: page >= 2 ? index + 1 + (page - 1) * limit - limit : index + 1,
    type: DEAL_SHEET_PROGRAM_TYPE_NAME[item.type] || item.type,
    startDate: startDate || '',
    endDate: endDate || '',
    isActiveName: ACTIVE_STATUS_COMMON_NAME[item.isActive] || item.isActive,
    createdByName: item.createdByName || '',
    checked: false,
  };
};

export const mapExpiredDealSheetItem = (item, index) => ({
  ...item,
  index: index + 1,
});
